import { UserTwoIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'

import { DispatchIndividualInput } from '../../../lib/types/models/trip-booking/trip-date-input'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { DispatchIndividualsForm } from './dispatch-individuals-form'

export const defaultSelectedData = { expandedRows: [], isAllSelected: false, rows: [] }

type DispatchModalProps = {
  isOpen: boolean
  tripDateId: number
  individualsCount?: number
  defaultValues?: Partial<DispatchIndividualInput>
  onCancel: () => void
  loading?: boolean
  onCreate: (data: DispatchIndividualInput) => Promise<void>
}
export function DispatchModal({ isOpen, onCancel, onCreate, ...props }: DispatchModalProps) {
  return (
    <Modal
      hideActions
      size={'medium'}
      isOpen={isOpen}
      icon={UserTwoIcon}
      onCancel={onCancel}
      title={'Dispatcher dans les réservations'}
    >
      <DispatchIndividualsForm
        {...props}
        buttonsConfig={twoButtonsConfig({ onConfirm: onCreate, onCancel })}
      />
    </Modal>
  )
}
